import { useMemo } from "react";
import { useEffect } from "react";
import { useHistoricoContext } from "../../../../Context/Historico";

import SpinnerComponent from "../../../Loding/Spinner";
import ComponenteHistorico from "../ComponenteHistorico";

interface IComponenteHistoricoClienteProps {
    ID_CASO?: number;
    showTipoContato?: boolean;
    height?: number;
}

export default function ComponenteHistoricoCliente(
    props: IComponenteHistoricoClienteProps
) {
    const { LoadHistoricoCliente, historico, loadingHistorico } =
        useHistoricoContext();

    const shouldLoad = useMemo(
        () => loadingHistorico.cliente === "preLoad",
        [loadingHistorico]
    );

    useEffect(() => {
        if (shouldLoad) {
            LoadHistoricoCliente();
        }
    }, [shouldLoad, historico, LoadHistoricoCliente, props.showTipoContato]);

    return loadingHistorico.cliente === "loaded" ? (
        <ComponenteHistorico
            historico={historico}
            ID_CASO={props.ID_CASO}
            height={props.height}
        />
    ) : (
        <SpinnerComponent />
    );
}
